import React from "react";
import Icon from '@ant-design/icons';


const ChangeSvg = () => {
 return(
    <svg fill="#000000" height="18px" width="18px" version="1.1" id="Layer_1" viewBox="0 0 490.429 490.429" stroke="#000000" stroke-width="5">
        <g id="SVGRepo_bgCarrier" stroke-width="3"/>
        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"/>
        <g id="SVGRepo_iconCarrier"> 
            <g> 
                <g> 
                    <g> 
                        <path d="M136.041,415.881c-27.2,0-56.107-17.387-56.107-49.493v-241.6c0-29.547,18.773-50.24,45.653-50.24h163.2l-35.093,35.093 c-4.267,4.053-4.373,10.88-0.213,15.04c4.053,4.267,10.88,4.373,15.04,0.213c0.107-0.107,0.213-0.213,0.213-0.213l53.333-53.333 c4.16-4.16,4.16-10.88,0-15.04L268.734,2.975c-4.267-4.053-10.987-3.947-15.04,0.213c-3.947,4.16-3.947,10.667,0,14.827 l35.2,35.093h-163.2c-38.933,0.107-67.093,30.187-67.093,71.68v241.6c0,39.68,34.027,70.827,77.44,70.827 c5.867,0,10.667-4.8,10.667-10.667C146.708,420.681,141.908,415.881,136.041,415.881z"/> 
                        <path d="M364.628,53.215c-5.867,0-10.667,4.8-10.667,10.667c0,5.867,4.8,10.667,10.667,10.667 c29.653,0,45.973,16.853,45.973,47.36v240.32c0,26.667-14.293,53.653-46.293,53.653H222.974l35.093-35.093 c4.053-4.267,3.947-10.987-0.213-15.04c-4.16-3.947-10.667-3.947-14.827,0l-53.333,53.333c-4.16,4.16-4.16,10.88,0,15.04 l53.333,53.333c4.267,4.053,10.987,3.947,15.04-0.213c3.947-4.16,3.947-10.667,0-14.827l-35.093-35.2h141.227 c39.787,0,67.627-30.827,67.627-74.987v-240.32C431.934,79.561,406.121,53.215,364.628,53.215z"/>
                    </g>
                </g>
            </g>
        </g>
    </svg>
 )
};


const ChangeIcon = props => <Icon component={ChangeSvg} {...props} />;


export default ChangeIcon;
